<template>
	<modal
		class="generous-tip-modal"
		title="Feeling Generous"
		first-button-text="CANCEL"
		second-button-text="yes, i'm generous"
		:dark-theme="darkTheme"
		:is-loading="isLoading"
		:first-button-action="closeModal"
		:second-button-action="addTip"
		@close="closeModal"
	>
		<div>
			<div class="sub-title pb-20">
				It looks like you are leaving a generous tip or have possibly made a
				mistake...
			</div>
			<dashed-line class="separator" />

			<div class="sub-title bold pt-20">Did you intend to leave</div>
			<div class="price bold pt-16 pb-16">
				<formatted-price :price="price" />
			</div>
			<div class="sub-title">which represents {{ percent }}% of the total?</div>
		</div>
	</modal>
</template>

<script>
import DashedLine from '@/components/DashedLine'
import Modal from './Modal.vue'
import FormattedPrice from '@/components/FormattedPrice.vue'

export default {
	name: 'GenerousTipModal',
	components: {
		FormattedPrice,
		DashedLine,
		Modal
	},
	props: {
		price: {
			type: [Number, String],
			required: true
		},
		percent: {
			type: [Number, String],
			required: true
		},
		isLoading: {
			type: Boolean,
			default: true
		},
		darkTheme: {
			type: Boolean,
			default: false
		}
	},

	methods: {
		closeModal() {
			this.$emit('close')
		},
		async addTip() {
			this.$emit('confirm-tips')
		}
	}
}
</script>

<style scoped lang="scss">
.generous-tip-modal.modal {
	color: #1d1b25;

	.sub-title {
		font-size: 14px;
	}

	.bold {
		font-weight: 700;
	}

	.price {
		font-size: 20px;
	}
}
</style>
